const clearHiddenTiersInCalculator = (calculator, ticketTypes) => {
  if (!calculator) {
    return;
  }

  (ticketTypes || []).forEach((ticketType) => {
    if (ticketType.visibility === "Hidden") {
      calculator.updateCart({ ticketTypeId: ticketType.id, quantity: 0 });
    }
  });
};

export default clearHiddenTiersInCalculator;
